// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","carousel":"styles_carousel___XGuX","container":"styles_container__doBBQ"};